import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCaseStudies, fetchCaseStudyIdAltRange } from './../../_redux/actions/CaseStudyActions';
import CaseStudy from './CaseStudy';
import { DefaultHeader } from './../parts/Parts';
import { motion } from "framer-motion";

const CaseStudySkeleton = () => (
    <div className="row case-study case-study-skeleton">
        <div className="col col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div className="skeleton-block skeleton-title" />
            <div className="skeleton-block skeleton-button" />
        </div>
        <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
            <div className="skeleton-tags">
                <div className="skeleton-block skeleton-tag" />
                <div className="skeleton-block skeleton-tag" />
                <div className="skeleton-block skeleton-tag" />
            </div>
            <div className="skeleton-block skeleton-text" />
            <div className="skeleton-block skeleton-text skeleton-text--short" />
        </div>
        <div className="col col-xs-12 col-sm-1 col-md-1 col-lg-1">
            <div className="skeleton-block skeleton-number" />
        </div>
    </div>
);

export const CaseStudies = () => {
    const dispatch = useDispatch();
    const caseStudies = useSelector((state) => state.caseStudies.caseStudies);
    const caseStudyIdAltRange = useSelector((state) => state.caseStudies.firstAndLast);
    const loading = useSelector((state) => state.caseStudies.loading);

    const [filteredCaseStudies, setFilteredCaseStudies] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedType, setSelectedType] = useState(null);


    useEffect(() => {
        dispatch(fetchCaseStudies());
        dispatch(fetchCaseStudyIdAltRange());
    }, [dispatch]);

    useEffect(() => {
        if (caseStudies.length) {
            setFilteredCaseStudies(caseStudies);

            const uniqueCategories = [
                ...new Set(caseStudies.map((caseStudy) => caseStudy.case_study_type))
            ].sort();

            setCategories(uniqueCategories);
        }
    }, [caseStudies]);

    const handleTypeClick = (type) => {
        if (selectedType === type) {
            setSelectedType(null);
            setFilteredCaseStudies(caseStudies);
        } else {
            setSelectedType(type);
            setFilteredCaseStudies(caseStudies.filter(cs => cs.case_study_type === type));
        }
    };

    const handleResetFilters = () => {
        setSelectedType(null);
        setFilteredCaseStudies(caseStudies);
    };

    return (
        <>
            <DefaultHeader defaultHeader="Case Studies" />
            {loading && filteredCaseStudies.length === 0 ? (
                <div className="component case-studies-component">
                    <div className="row case-studies-component--one">
                        <div className="col col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <div className="skeleton-block skeleton-range" />
                        </div>
                        <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
                            <div className="skeleton-tags">
                                <div className="skeleton-block skeleton-filter" />
                                <div className="skeleton-block skeleton-filter" />
                                <div className="skeleton-block skeleton-filter" />
                            </div>
                        </div>
                    </div>
                    <div className="row case-studies-component--two">
                        <div className="col col-xs-12">
                            {[...Array(4)].map((_, i) => <CaseStudySkeleton key={i} />)}
                        </div>
                    </div>
                </div>
            ) : filteredCaseStudies.length > 0 ? (
                <motion.div
                    className="component case-studies-component"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}>
                    <div className="row case-studies-component--one">
                        <div className="col col-xs-12 col-sm-3 col-md-3 col-lg-3">
                            <p className="case-study-id-alt-range">{caseStudyIdAltRange.first || ""} - {caseStudyIdAltRange.last || ""}</p>
                        </div>
                        <div className="col col-xs-12 col-sm-8 col-md-8 col-lg-8">
                            <div className="case-studies-type-filter">
                                {categories.map((type) => (
                                    <button
                                        key={type}
                                        className={`filter ${selectedType === type ? 'active' : ''}`}
                                        onClick={() => handleTypeClick(type)}
                                    >
                                        {type}
                                    </button>
                                ))}
                                <button
                                    className="filter reset"
                                    onClick={handleResetFilters}
                                >
                                    All
                                </button>
                            </div>
                        </div>

                    </div>
                    <div className="row case-studies-component--two">
                        <div className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            {filteredCaseStudies.map((caseStudy) => (
                                <CaseStudy key={caseStudy.case_study_id} caseStudy={caseStudy} />
                            ))}
                        </div>
                    </div>
                </motion.div>
            ) : null}
        </>
    );
};
